import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ReportPopupService {

  private readonly loginApiUrl = environment.url.HEATWAVE_STAGING_API_URL + 'loginMetwise';

  // TODO: move this into environment.ts once you confirm the deployed host
  // e.g. environment.url.UGMT_API_URL + 'createBasicUser'
  private readonly createBasicUserUrl = environment.url.HEATWAVE_STAGING_API_URL + 'ugmt/createBasicUser';

  constructor(private http: HttpClient) {}

  authenticate(username: string, password: string): Observable<any> {
    return this.http.post<any>(this.loginApiUrl, { userName: username, passWord: password });
  }

  createBasicUser(payload: { name: string; email: string; phoneNumber: string }): Observable<any> {
    return this.http.post<any>(this.createBasicUserUrl, payload);
  }

  private buildAndSaveMetaInfo(data: any, countryEntry: any, username: string): void {
    const rawLocationType = (data.locationType || '').toUpperCase();
    const locType = rawLocationType
      ? rawLocationType.charAt(0) + rawLocationType.slice(1).toLowerCase()
      : 'Country';

    const metaInfo: any = {
      userId: '',
      username: username,
      firstName: data.firstName || '',
      lastName: data.lastName || '',
      email: data.email || '',
      mobileNo: data.phoneNumber || '',
      userDetailsJson: {
        data: {
          locType: locType,
          location: { country: [countryEntry] }
        },
        scope: null
      },
      lastLoginTs: new Date().toISOString(),
      status: true,
      customerId: 'f7d86063-2db1-4dd7-bbdf-0e4dc6031744',
      customerName: 'heatwavecustomer'
    };

    localStorage.setItem('metaInfo', JSON.stringify(metaInfo));
  }

  setMetaInfo(data: any, username: string): Promise<void> {
    const rawLocationType = (data.locationType || '').toUpperCase();
    const countryEntry: any = {
      countryName: 'INDIA',
      countryUUID: '00cb31c7-2928-4e6d-adcc-443d478c90d6'
    };

    if (rawLocationType === 'STATE' && data.locationName && data.locationUUID) {
      countryEntry.state = [{
        stateName: data.locationName.toUpperCase(),
        stateUUID: data.locationUUID
      }];
      this.buildAndSaveMetaInfo(data, countryEntry, username);
      return Promise.resolve();
    }

    const extractUUID = (obj: any): string => {
      if (!obj) { return ''; }
      const d = obj.data || obj;
      const entry = Array.isArray(d) ? d[0] : d;
      if (!entry) { return ''; }
      if (typeof entry === 'string') { return entry; }
      if (entry.parentUUID) { return entry.parentUUID.toString(); }
      if (entry.locationUUID) { return entry.locationUUID.toString(); }
      const keys = Object.keys(entry);
      const uuidKey = keys.find(k => k.toLowerCase().includes('uuid'));
      return (uuidKey ? entry[uuidKey] : (entry.id || entry.uId || '')).toString();
    };

    const extractName = (obj: any): string => {
      if (!obj) { return ''; }
      const d = obj.data || obj;
      const entry = Array.isArray(d) ? d[0] : d;
      if (!entry || typeof entry === 'string') { return ''; }
      if (entry.parentName) { return entry.parentName.toString(); }
      if (entry.locationName) { return entry.locationName.toString(); }
      const keys = Object.keys(entry);
      const nameKey = keys.find(k => k.toLowerCase().includes('name') || k === 'ln');
      return (nameKey ? entry[nameKey] : '').toString();
    };

    if (rawLocationType === 'DISTRICT' && data.locationUUID) {
      const parentUrl =
        `${environment.url.HEATWAVE_STAGING_API_URL}location/directParent/${data.locationUUID}/DISTRICT/STATE`;
      return this.http.get<any>(parentUrl).toPromise().then(parentRes => {
        if (parentRes && parentRes.status === false) {
          throw new Error(parentRes.message || 'Failed to fetch state info');
        }
        countryEntry.state = [{
          stateName: extractName(parentRes).toUpperCase(),
          stateUUID: extractUUID(parentRes),
          district: [{
            districtName: (data.locationName || '').toUpperCase(),
            districtUUID: data.locationUUID
          }]
        }];
        this.buildAndSaveMetaInfo(data, countryEntry, username);
      });
    }

    if (rawLocationType === 'BLOCK' && data.locationUUID) {
      const districtUrl =
        `${environment.url.HEATWAVE_STAGING_API_URL}location/directParent/${data.locationUUID}/BLOCK/DISTRICT`;
      return this.http.get<any>(districtUrl).toPromise().then(districtRes => {
        if (districtRes && districtRes.status === false) {
          throw new Error(districtRes.message || 'Failed to fetch district info');
        }
        const districtUUID = extractUUID(districtRes);
        const districtName = extractName(districtRes);
        const stateUrl =
          `${environment.url.HEATWAVE_STAGING_API_URL}location/directParent/${districtUUID}/DISTRICT/STATE`;
        return this.http.get<any>(stateUrl).toPromise().then(stateRes => {
          if (stateRes && stateRes.status === false) {
            throw new Error(stateRes.message || 'Failed to fetch state info');
          }
          countryEntry.state = [{
            stateName: extractName(stateRes).toUpperCase(),
            stateUUID: extractUUID(stateRes),
            district: [{
              districtName: districtName,
              districtUUID: districtUUID,
              block: [{
                blockName: (data.locationName || '').toUpperCase(),
                blockUUID: data.locationUUID
              }]
            }]
          }];
          this.buildAndSaveMetaInfo(data, countryEntry, username);
        });
      });
    }

    this.buildAndSaveMetaInfo(data, countryEntry, username);
    return Promise.resolve();
  }
}